/*
 * Click-to-copy behaviour for the sale-code chip rendered by snippets/sale-code.liquid.
 * Uses event delegation so it works for any chip on the page, including
 * cards added via section rendering (filters, pagination, etc.).
 */
(function () {
  if (window.__saleCodeBound) return;
  window.__saleCodeBound = true;

  function flashCopied(btn) {
    btn.classList.add('is-copied');
    window.setTimeout(function () {
      btn.classList.remove('is-copied');
    }, 1100);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  // Use capture phase so we beat any product-card link handlers
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.sale-code');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var code = btn.getAttribute('data-sale-code');
      if (!code) return;
      copyText(code)
        .then(function () {
          flashCopied(btn);
        })
        .catch(function () {
          flashCopied(btn);
        });
    },
    true
  );
})();
